<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="location"
      :rules="rules"
      ref="locationForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="value"
        label="Terület"
        :error="errors.value ? errors.value[0] : null"
      >
        <el-input v-model="location.value" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'locationId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        errors: {
          value: null,
        },
        location: {},
        rules: {
          value :[
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' },
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Terület';
        } else if (this.type === 'update') {
          return 'Terület módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['locationForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.value = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('location/add', this.location);
              } else if (this.type === 'update') {
                await this.$store.dispatch('location/update', this.location);
              }
              this.$store.dispatch('location/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
              if (e.data && e.data.errors) {
                this.errors = e.data.errors;
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.locationId) {
        this.location = await this.$store.dispatch('location/fetch', this.locationId);
      }
      this.loading = false;
    }
  }
</script>
